import { render, staticRenderFns } from "./PhraseTermPickerComponent.vue?vue&type=template&id=063232d3&scoped=true"
import script from "./PhraseTermPickerComponent.vue?vue&type=script&lang=js"
export * from "./PhraseTermPickerComponent.vue?vue&type=script&lang=js"
import style0 from "./PhraseTermPickerComponent.vue?vue&type=style&index=0&id=063232d3&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063232d3",
  null
  
)

export default component.exports